import React from 'react';

function A8AdMyVision() {
    return (
        <div>
            <p>PR: 「この夏に向けて」国内外の人気ホテルを大手サイトの格安料金で予約しませんか?</p>
            <a href="https://px.a8.net/svt/ejp?a8mat=3TJHEH+23M45E+4X1W+5ZEMP" rel="nofollow">
                {/* @ts-ignore */}
                <img border="0" width="320" height="50" alt="" src="https://www28.a8.net/svt/bgt?aid=231016409127&wid=003&eno=01&mid=s00000022946001005000&mc=1" />
            </a>
            {/* @ts-ignore */}
            <img border="0" width="1" height="1" src="https://www17.a8.net/0.gif?a8mat=3TJHEH+23M45E+4X1W+5ZEMP" alt="" />
        </div>
    );
}

export default A8AdMyVision;
